import * as TabsPrimitive from '@radix-ui/react-tabs'
import * as React from 'react'

import { classes } from '../utils'

const Tabs = TabsPrimitive.Root

const TabsList = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={classes(
      'inline-flex items-center justify-center rounded-lg bg-background-surface p-0.5 text-foreground-subtle',
      className,
    )}
    {...props}
  />
))
TabsList.displayName = TabsPrimitive.List.displayName

const TabsTrigger = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={classes(
      'flex h-7 items-center justify-center whitespace-nowrap rounded-md px-3 text-foreground-subtle disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-foreground-normal',
      'outline-none focus:outline-2 focus:outline-offset-[-2px] focus:outline-focus-outline focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-focus-outline',
      className,
    )}
    {...props}
  />
))
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName

const TabsContent = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={classes('outline-none', className)}
    {...props}
  />
))
TabsContent.displayName = TabsPrimitive.Content.displayName

const RadixTabs = Tabs as typeof Tabs & {
  List: typeof TabsList
  Trigger: typeof TabsTrigger
  Content: typeof TabsContent
}

RadixTabs.List = TabsList
RadixTabs.Trigger = TabsTrigger
RadixTabs.Content = TabsContent

export { RadixTabs }
